
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-modifier/-embroider-implicit-modules.js";
